import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import {
  BUSINESS_CONNECTORS_SETTINGS_PATH,
  handoffBusinessOAuthPopupCancel,
} from "./businessDigestSetup";

/**
 * Handles denied/cancelled business OAuth callbacks that land on `/sources/add`.
 * Popup flows hand off to the opener; full-tab flows return to Connectors.
 *
 * @example
 * <BusinessOAuthLegacyCallbackHandler
 *   callback={{ provider: "granola", isPopupReturn: true, cancelled: true }}
 * />
 */
const BusinessOAuthLegacyCallbackHandler = ({ callback }) => {
  useEffect(() => {
    if (!callback?.isPopupReturn) {
      return;
    }
    handoffBusinessOAuthPopupCancel(callback.provider);
  }, [callback]);

  if (!callback) {
    return null;
  }

  return <Navigate to={BUSINESS_CONNECTORS_SETTINGS_PATH} replace />;
};

export default BusinessOAuthLegacyCallbackHandler;
